// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FN7y","top":"styles_top__3RYB_"};